<template>
  <div class="flex flex-col gap-1 md:gap-2" style="position: relative">
    <Divider class="w-auto mx-0" />
    <span @click="deleteJob(item.id)" class="close">x</span>
    <div class="flex justify-between gap-1 items-center">
      <p class="title-sm text-primary30">{{ item.subtitle }}</p>
      <p class="title-sm text-primary30">
        {{ item.started }}{{ item.finished ? item.finished : '' }}
      </p>
    </div>
    <p class="title-md">
      {{ item.title }}
    </p>
    <p class="body-md text-neutral20">
      {{ item.description }}
    </p>
    <Divider class="w-auto mx-0" />
  </div>
</template>

<script>
import Divider from '@/Components/Divider'
import { validateRequiredKeys } from '@/utilities.helpers.js'

export default {
  name: 'ProfileListItemDelete',
  components: { Divider },
  props: {
    item: {
      required: true,
      validator: value =>
        validateRequiredKeys(value, ['title', 'subtitle', 'started', 'description']),
    },
    ruta: String
  },
  methods: {
    deleteJob (key) {
      this.$swal.fire({
        title: 'Confirmación:',
        text: '¿Estás seguro que quieres borrar ese dato?',
        showConfirmButton: true,
        showCancelButton: true,
      })
      .then(result => {
        if (result.isConfirmed) {
          this.$inertia.post(this.$route(`profile.${this.ruta}`), { id: key }, {
            preserveState: true,
            onError: errors => {
              this.$swal.fire({
                title: '¡Error!',
                text: 'Parece que ha ocurrido un error. Revisa los datos e intenta de nuevo.',
              })
            },
            onSuccess: () => {
              this.$swal.fire({
                title: 'Registro Elimniado!',
                text: 'Tus datos se guardaron con éxito',
              })
            },
          })
        }
      })
    }
  }
}
</script>

<style>
.close{
  width: 30px;
  padding: .1em;
  position: absolute;
  cursor: pointer;
  float: right;
  text-align: center;
  margin-top: 40px;
  right: 0px;
  border: 2px solid #212121;
  border-radius: 50%;
}
</style>
